<form [formGroup]="formGroup" novalidate fxLayout="column">
    <div fxLayout="column">
        <div fxLayout="row">
            <mat-form-field fxFlex="1 1 70%">
                <mat-label>Owner</mat-label>
                <mat-select formControlName="owner" [disabled]="!isReportingAdmin">
                    <mat-option *ngFor="let designer of designers" [value]="designer">
                        {{designer}}</mat-option>
                </mat-select>
                <mat-icon *ngIf="!isReportingAdmin" matSuffix>lock</mat-icon>
                <mat-icon *ngIf="isReportingAdmin" matSuffix>lock_open</mat-icon>
            </mat-form-field>
        </div>
        <div fxLayout="row">
            <mat-form-field fxFlex="1 1 70%">
                <mat-label>Publisher</mat-label>
                <mat-select formControlName="publisher" [disabled]="!isReportingAdmin && currentUser !== owner.value">
                    <mat-option *ngFor="let designer of designers" [value]="designer">
                        {{designer}}</mat-option>
                </mat-select>
                <mat-icon *ngIf="!isReportingAdmin && currentUser !== owner.value" matSuffix>lock</mat-icon>
                <mat-icon *ngIf="isReportingAdmin || currentUser === owner.value" matSuffix>lock_open</mat-icon>
            </mat-form-field>
        </div>
        <div fxFlex="0 0 auto" fxLayout="column" fxLayoutGap="0.5em">
            <mat-form-field fxFlex="1 1 70%">
                <mat-label>Collaborators (Edit / View / Run)</mat-label>
                <mat-select formControlName="collaborators" multiple
                    [disabled]="!isReportingAdmin && currentUser !== owner.value">
                    <mat-option *ngFor="let designer of designers" [value]="designer">
                        {{designer}}</mat-option>
                </mat-select>
                <mat-icon *ngIf="!isReportingAdmin && currentUser !== owner.value" matSuffix>lock</mat-icon>
                <mat-icon *ngIf="isReportingAdmin || currentUser === owner.value" matSuffix>lock_open</mat-icon>
            </mat-form-field>
            <mat-form-field fxFlex="1 1 70%">
                <mat-label>Viewer (View / Run)</mat-label>
                <mat-select formControlName="viewers" multiple
                    [disabled]="!isReportingAdmin && currentUser !== owner.value">
                    <mat-option *ngFor="let designer of designers" [value]="designer">
                        {{designer}}</mat-option>
                </mat-select>
                <mat-icon *ngIf="!isReportingAdmin && currentUser !== owner.value" matSuffix>lock</mat-icon>
                <mat-icon *ngIf="isReportingAdmin || currentUser === owner.value" matSuffix>lock_open</mat-icon>
            </mat-form-field>
        </div>
    </div>
</form>
